module.exports = __webpack_public_path__ + "img/32.6fc1aeb0.png";